import WrappedPromise, {PromiseArg} from "../data/helpers/WrappedPromise";
import useExternalStore from "./useExternalStore";
import {useMemo} from "react";

const usePromise = <T extends unknown>(promise: PromiseArg<T>, deps: any[]) : T => {
    const wrappedPromise = useMemo(() => new WrappedPromise(promise), deps);
    return useExternalStore(wrappedPromise);
}

export default usePromise;